import { render, staticRenderFns } from "./RepairScreen.vue?vue&type=template&id=5164d2a1&scoped=true&"
import script from "./RepairScreen.vue?vue&type=script&lang=js&"
export * from "./RepairScreen.vue?vue&type=script&lang=js&"
import style0 from "./RepairScreen.vue?vue&type=style&index=0&id=5164d2a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5164d2a1",
  null
  
)

export default component.exports